exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@media (max-width:768px){a:active{opacity:.5}.send-button{display:inline-block;width:110px;height:30px;text-align:center;font-size:14px;font-weight:400;padding:7px 0;color:#fff;position:relative;background:#3ec19d;box-shadow:0 4px 4px rgba(0,0,0,.25);border-radius:10px;line-height:18px;padding-left:15px}.send-button:after{content:\"\";display:block;position:absolute;left:50%;top:11px;margin-left:-30px;width:15px;height:14px;background:url(" + require("../../images/shape.svg") + ") 50% no-repeat}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/sass-loader!./directives/sendApplicationLink/sendApplicationLink.scss
// module id = 525
// module chunks = 0